<template>
  <VCard v-if="influencer.similar_artists.length" class="tw-w-full" padding="5">
    <section class="favoriteMainWrapper">
      <VText class="tw-mb-6 tw-block" cfg="sans/20/bold" html-tag="h2">
        {{ $t('influencer.profile.slug.favorite.favorite00') }}
      </VText>
      <div class="cardWrap">
        <FavoriteCard
          v-for="artist in influencer.similar_artists"
          :key="artist.name"
          class="favoriteCard"
          :value="artist"
        />
      </div>
    </section>
  </VCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import FavoriteCard from './favorite/Card.vue'

import VCard from '~/components/ui/VCard.vue'
import VText from '~/components/ui/VText.vue'

import type { Influencer } from '~/types/influencer'
import type { PropType } from 'vue'

export default defineComponent({
  components: {
    FavoriteCard,
    VText,
    VCard,
  },
  props: {
    influencer: {
      type: Object as PropType<Influencer>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.favoriteMainWrapper {
  @apply tw-relative tw-flex tw-w-full tw-flex-col;
}

.cardWrap {
  @apply tw-grid tw-grid-cols-1 tw-gap-6;

  @screen sm {
    @apply tw-grid-cols-2;
  }

  @screen md {
    @apply tw-grid-cols-3;
  }
}
</style>
